import { Alert, Button, TextField } from "@mui/material";
import Typography from "@mui/material/Typography/Typography";
import React from "react";
import { NotrufResponseAddress } from "../utils/WhatsAppBot";
import { Backend } from "../utils/Backend";
import { NotrufList, TabEnum } from "../App";

export default function ViaAdresse({ changeTab }: { changeTab: (tab: number) => void }) {

    const [address, setAddress] = React.useState({
        street: "",
        houseNumber: "",
        zipCode: "",
        city: ""
    });
    const [answer, setAnswer] = React.useState<NotrufResponseAddress>();
    const [error, setError] = React.useState(false);
    const [formSubmittable, setFormSubmittable] = React.useState(false);
    const resultsRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (address.street === "" || address.zipCode === "" || address.city === "" || address.zipCode === "") {
            setFormSubmittable(false);
        } else {
            setFormSubmittable(true);
        }
    }, [address]);

    const send = (street: string, houseNumber: string, zipCode: string, city: string) => {
        Backend.sendRequest("GET", "/byaddress?street=" + street.trim() + "&houseNumber=" + houseNumber.trim() + "&zipCode=" + zipCode.trim() + "&city=" + city.trim())
            .then((response: NotrufResponseAddress) => {
                setAnswer(response);

                setError(false);
            }).catch(() => {
                setError(true);
            }).finally(() => {
                console.log(resultsRef.current);
                if (resultsRef.current) {
                    setTimeout(() => {
                        resultsRef.current?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                }
            });
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setAddress(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", marginBottom: 15 }}>
                <Typography>
                    Bitte geben Sie Ihre Adresse an, damit wir Sie Ihrem Objekt zuordnen können.
                </Typography>
            </div>

            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    send(address.street, address.houseNumber, address.zipCode, address.city);
                }}
            >
                <TextField variant="outlined" fullWidth label="Straße" name="street" value={address.street} onChange={handleChange} style={{ marginBottom: 10 }} />
                <TextField variant="outlined" fullWidth label="Hausnummer" name="houseNumber" value={address.houseNumber} onChange={handleChange} style={{ marginBottom: 10 }} />
                <TextField variant="outlined" fullWidth label="PLZ" name="zipCode" value={address.zipCode} onChange={handleChange} style={{ marginBottom: 10 }} />
                <TextField variant="outlined" fullWidth label="Stadt" name="city" value={address.city} onChange={handleChange} />
                <div style={{ justifyContent: "center", display: "flex", marginTop: 2 }}>
                    <Button type="submit" disabled={!formSubmittable}>
                        Senden
                    </Button>
                </div>
            </form>

            {error && <Alert severity='error'>Unsere Server werden gerade gewartet. Bitte probieren Sie es in wenigen Minuten erneut.</Alert>}

            <div ref={resultsRef}>
                {answer && <>
                    <div style={{ marginTop: 15 }} />
                    {answer.state === "NOT_A_NUMBER" &&
                        <Alert severity='error'>
                            Die eingegebene Rufnummer ist ungültig. Bitte überprüfen Sie Ihre Eingabe.
                        </Alert>
                    }
                    {answer.state === "UNKNOWN_USER" &&
                        <Alert severity='warning'>
                            Sehr geehrte Eigentümer:innen,<br /> sehr geehrte Kund:innen,<br />
                            <br />
                            leider konnten wir Ihre Adresse in unserem System nicht zuordnen.

                            <br />
                            <b>In dringenden Fällen</b> rufen Sie bitte unsere allgemeine Störungsnummer an:
                            <Button href='tel:+4922032070123'>
                                02203 2070123
                            </Button>
                            <br />
                            Alternativ können Sie Sich auch über Ihre Telefonnummer verifizieren. Klicken Sie dazu auf den Reiter <Button onClick={(e) => {
                                e.preventDefault();
                                changeTab(TabEnum.ViaRufnummer);
                            }}>Via Telefonnummer</Button> und geben Sie Ihre Rufnummer ein.
                        </Alert>
                    }
                    {answer.state === "OK" && <div>
                        Wir haben für Ihre Adresse {answer.address} die folgenden Objekte gefunden:
                        <NotrufList entries={answer.objs} />
                    </div>}
                </>}
            </div>
        </>
    )
};